import React from "react";
import ReactSelect from "react-select";
const MultiSelectTwo = ({
  className,
  options,
  value,
  onChange,
  disabled,
  isDisabled = false,
  label,
  disableSearch = true,
  hasSelectAll = true,
  menuPortalTarget = false,
}) => {
  const customStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      width: "256px",
    }),
  };
  return (
    <ReactSelect
      className={className || ""}
      options={options}
      styles={customStyles}
      value={value || []}
      onChange={(e) => onChange(e)}
      labelledBy={"object"}
      isOptionDisabled={(option) => option.disabled}
      disableSearch={disableSearch}
      isDisabled={isDisabled}
      overrideStrings={{
        selectSomeItems: label || "Select",
        allItemsAreSelected: "All items are selected.",
        selectAll: "Select All",
        search: "Search",
      }}
      // menuPortalTarget={document.body}
      menuPortalTarget={menuPortalTarget === null ? menuPortalTarget : document.body}
      isMulti={true}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
    />
  );
};
export default MultiSelectTwo;
